// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3TL0PClBZC3M_tM7kviBiz"};